import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "container",
  style: {"margin-top":"100px"}
}
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col-md-8" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "card-title mb-4 text-center" }
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = { class: "h5 mb-3" }
const _hoisted_9 = { class: "row g-3" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "form-label" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "form-label" }
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = { class: "form-label" }
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = { class: "form-label" }
const _hoisted_18 = { class: "mb-4" }
const _hoisted_19 = { class: "h5 mb-3" }
const _hoisted_20 = { class: "row g-3" }
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "form-label" }
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "mb-3" }
const _hoisted_25 = { class: "form-label" }
const _hoisted_26 = { class: "form-label" }
const _hoisted_27 = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_28 = {
  key: 1,
  class: "alert alert-success",
  role: "alert"
}
const _hoisted_29 = { class: "d-flex justify-content-end" }
const _hoisted_30 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t("profile.title")), 1),
            _createElementVNode("form", {
              onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateProfile && _ctx.updateProfile(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.$t("profile.personalInfo.title")), 1),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("profile.personalInfo.firstName")), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.profile.firstName) = $event)),
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.profile.firstName]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("profile.personalInfo.lastName")), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.profile.lastName) = $event)),
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.profile.lastName]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("profile.personalInfo.email")), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.profile.email) = $event)),
                      required: "",
                      disabled: ""
                    }, null, 512), [
                      [_vModelText, _ctx.profile.email]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("profile.personalInfo.companyName")), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.profile.companyName) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.profile.companyName]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("h4", _hoisted_19, _toDisplayString(_ctx.$t("profile.changePassword.title")), 1),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("profile.changePassword.currentPassword")), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "password",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.passwordChange.currentPassword) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.passwordChange.currentPassword]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t("profile.changePassword.newPassword")), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "password",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.passwordChange.newPassword) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.passwordChange.newPassword]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("profile.changePassword.confirmPassword")), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "password",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.passwordChange.confirmPassword) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.passwordChange.confirmPassword]
                      ])
                    ])
                  ])
                ])
              ]),
              (_ctx.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.error), 1))
                : _createCommentVNode("", true),
              (_ctx.success)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.success), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-primary",
                  disabled: _ctx.loading
                }, _toDisplayString(_ctx.loading
                      ? _ctx.$t("profile.buttons.saving")
                      : _ctx.$t("profile.buttons.saveChanges")), 9, _hoisted_30)
              ])
            ], 32)
          ])
        ])
      ])
    ])
  ]))
}